/* Giftagoods · shared behaviour: reveal-on-scroll for .gg-r elements */
(function () {
  if (window.__ggBase) return;
  window.__ggBase = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  if (reduce || editor || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('gg-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function scan() {
    document.querySelectorAll('.gg-r:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.96) el.classList.add('is-in');
      else io.observe(el);
    });
  }
  window.ggRevealScan = scan;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();